import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as Maps from '../store/map';

class LsportsPull extends Component {
    componentDidMount() {
        let isPrematchLoadingStarted = this.props.lSports.prematch.isLoadingStarted;
        let isInplayLoadingStarted = this.props.lSports.inplay.isLoadingStarted;

        if (isPrematchLoadingStarted !== true) {
            this.props.lsportsActions.prematch.startLoading(2);
            this.props.lsportsActions.prematch.getEvents();
        }

        if (isInplayLoadingStarted !== true) {
            this.props.lsportsActions.inplay.startLoading(2);
            this.props.lsportsActions.inplay.getEvents();
        }
    }

    render() {
        return <React.Fragment children={this.props.children} />;
    }
}

export default connect(Maps.mapLSportsStateToProps, Maps.mapLSportsDispatchToProps)(LsportsPull);
